import Grid2 from '@thirdparty-framework/mui/material/Grid';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Grid2 role="tabpanel" hidden={value !== index} id={index} {...other}>
      {value === index && children}
    </Grid2>
  );
}

export default CustomTabPanel;
